

































































import Vue from 'vue'
import Component from 'vue-class-component'
import appManager from '@/services/AppManager'
import * as db from '@/core/Database'
import * as api from '@/services/ApiService'
import { Company } from '@/core/Types'
import Spinner from '@/components/Spinner.vue'
import FormTextField from '@/components/FormTextField.vue'
import { isValidEmail } from '@/core/Utils'

@Component({
    components: {
        Spinner,
        FormTextField
    }
})
export default class CompanyProfileView extends Vue {
    // default view
    company: Company|null = null
    editCounter: number = 0 // simply way to force a refresh after editing

    // edit view
    isEditDialogVisible: boolean = false
    isSaving: boolean = false
    editName: string = ''
    editNameErrorMessage: string|null = null
    editEmail: string = ''
    editEmailErrorMessage: string|null = null
    formErrorMessage: string|null = null

    // noinspection JSUnusedGlobalSymbols
    async created() {
        const user = appManager.userManager.state?.user
        if (user && user.data.companyId) {
            const companyData = await db.getCompanyData(user.data.companyId)
            if (companyData) {
                this.company = {
                    id: user.data.companyId,
                    data: companyData
                }
            }
        }
    }

    onEditPressed() {
        if (this.company?.data) {
            this.editName = this.company.data.name
            this.editEmail = this.company.data.email
            this.editNameErrorMessage = null
            this.editEmailErrorMessage = null
            this.formErrorMessage = null
            this.isSaving = false
            this.isEditDialogVisible = true
        }
    }

    async onSavePressed() {
        const newName = this.editName.trim()
        const newEmail = this.editEmail.trim().toLowerCase()
        this.editNameErrorMessage = newName ? null : 'Must specify a name'
        this.editEmailErrorMessage = isValidEmail(newEmail) ? null : 'Specify a valid email address'
        if (!this.company || this.editNameErrorMessage || this.editEmailErrorMessage)
            return

        this.isSaving = true

        try {
            await api.editCompany({
                companyId: this.company.id,
                newName: newName,
                newEmail: newEmail
            })

            this.company.data.name = newName
            this.company.data.email = newEmail
            this.editCounter += 1 // force a refresh
            this.isEditDialogVisible = false

            appManager.alertManager.publishSuccess('Company profile updated')
        } catch (error) {
            console.error(`Error Editing Company: ${error}`)
            this.formErrorMessage = 'There was an error editing the company. Please try again later.'
        }

        this.isSaving = false
    }
}
